import { compose, withState } from 'recompose'

const withStateChanged = (options = {}) => {
  const {
    getInitialState = () => null,
  } = options
  return compose(
    withState('isStateChanged', 'setIsStateChanged', false),
    withState('tempState', 'setTempState', getInitialState),
  )
}

export default withStateChanged



// WEBPACK FOOTER //
// ./src/hocs/bases/withStateChanged.js